import Swiper, {Navigation, Scrollbar} from "swiper";
import GLightbox from 'glightbox';

const aboutSlider = () => {

    // init Swiper:
    const swiper1 = new Swiper('[data-about-slider]', {
        modules: [Scrollbar, Navigation],
        scrollbar: {
            el: '.about__slider_scrollbar',
            draggable: true,
        },
        slidesPerView: 1,
        spaceBetween: 24,
        navigation: {
            nextEl: '.about__slider_next',
            prevEl: '.about__slider_prev',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: "auto",
            }
        }
    });

}

const certificateLightBox = () => {

    const certificate = GLightbox({
        selector: '.table__item'
    });

};

const showMoreCertificate = () => {
    const $show_more = $('[data-show-more]');
    const $table__item = $('.table__item');
    $show_more.on('click', function (e) {
        e.preventDefault();
        $table__item.removeClass('d-none')
        $(this).remove();
    });
};

aboutSlider()
certificateLightBox()
showMoreCertificate()
